import { render, staticRenderFns } from "./AddCutoffGroup.vue?vue&type=template&id=1d152369"
import script from "./AddCutoffGroup.vue?vue&type=script&lang=js"
export * from "./AddCutoffGroup.vue?vue&type=script&lang=js"
import style0 from "./AddCutoffGroup.vue?vue&type=style&index=0&id=1d152369&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports